var body = $('body');
var max_pages = parseInt('{{pagination.pages}}');

window.lazySizesConfig = window.lazySizesConfig || {};
window.lazySizesConfig.loadHidden = false;

document.addEventListener('lazyloaded', function (e) {
    'use strict';
    if ($(e.target).parent('.site-cover').length) {
        $(e.target).parent().addClass('initialized');
    }
});

$(function () {
    'use strict';
    video();
    gallery();
    player();
    pagination();
    popup();
    subscribe();
});

function video() {
    'use strict';
    $('.post-content').fitVids();
}

function gallery() {
    'use strict';
    var images = document.querySelectorAll('.kg-gallery-image img');

    images.forEach(function (image) {
        var container = image.closest('.kg-gallery-image');
        var width = image.attributes.width.value;
        var height = image.attributes.height.value;
        var ratio = width / height;
        container.style.flex = ratio + ' 1 0%';
    });
}

function player() {
    'use strict';
    var player = jQuery('#player');
    var playerAudio = jQuery('.player-audio');
    var playerProgress = jQuery('.player-progress');
    var timeCurrent = jQuery('.player-time-current');
    var timeDuration = jQuery('.player-time-duration');
    var playButton = jQuery('.button-play');
    var backwardButton = jQuery('.player-backward');
    var forwardButton = jQuery('.player-forward');
    var playerSpeed = 1;
    var speedButton = jQuery('.player-speed');

    jQuery('.site').on('click', '.js-play', function () {
        var clicked = jQuery(this);

        if (clicked.hasClass('post-play')) {
            var episode = clicked.closest('.post');
            if (player.attr('data-playing') !== episode.attr('data-id')) {
                playerAudio.attr('src', episode.attr('data-url'));
                jQuery('.post[data-id="' + player.attr('data-playing') + '"]').find('.post-play').removeClass('playing');
                player.attr('data-playing', episode.attr('data-id'));
                player.find('.post-image').attr('src', episode.find('.post-image').attr('data-srcset').replace(/\s+[0-9]+(\.[0-9]+)?[wx]/g, "").split(/,/)[0]);
                player.find('.post-title').text(episode.find('.post-image').attr('alt'))
                player.find('.post-meta time').attr('datetime', episode.find('.post-meta-date time').attr('datetime'));
                player.find('.post-meta time').text(episode.find('.post-meta-date time').text());
            }
        }

	if (playerAudio[0].paused) {
            var playPromise = playerAudio[0].play();
            if (playPromise !== undefined) {
                playPromise
                    .then(function () {
                        clicked.addClass('playing');
                        playButton.addClass('playing');            
                	playButton.removeClass('icon-pause');
                        jQuery('.post[data-id="' + player.attr('data-playing') + '"]').find('.post-play').addClass('playing');
                        jQuery('body').addClass('player-opened');
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            }
        } else {
            playerAudio[0].pause();
            clicked.removeClass('playing');
	    clicked.addClass('icon-pause');
            playButton.removeClass('playing');
            jQuery('.post[data-id="' + player.attr('data-playing') + '"]').find('.post-play').removeClass('playing');
        } 
    });

    playerAudio.on('timeupdate', function () {
        const duration = isNaN(playerAudio[0].duration) ? 0 : playerAudio[0].duration;
        timeDuration.text(
            new Date(duration * 1000).toISOString().substring(11, 19)
        );
        playerAudio[0].addEventListener('timeupdate', function (e) {
            timeCurrent.text(
                new Date(e.target.currentTime * 1000)
                    .toISOString()
                    .substring(11, 19)
            );
            playerProgress.css(
                'width',
                (e.target.currentTime / playerAudio[0].duration) * 100 + '%'
            );
        });
    });

    backwardButton.on('click', function () {
        playerAudio[0].currentTime = playerAudio[0].currentTime - 10;
    });

    forwardButton.on('click', function () {
        playerAudio[0].currentTime = playerAudio[0].currentTime + 30;
    });

    speedButton.on('click', function () {
        if (playerSpeed < 2) {
            playerSpeed += 0.5;
        } else {
            playerSpeed = 1;
        }

        playerAudio[0].playbackRate = playerSpeed;
        speedButton.text(playerSpeed + 'x');
    });
}


function player_old() {
    'use strict';
    var player = jQuery('.player');
    var playerAudio = jQuery('.player-audio');
    var playerMedia = player.find('.post-media');
    var playerThumbnail = player.find('.post-image');
    var playerTitle = player.find('.post-title-link');
    var playerMeta = player.find('.post-meta');
    var playerProgress = jQuery('.player-progress');
    var playerSpeed = 1;
    var buttonEpisode;
    var buttonPlay = jQuery('.player-button-play');
    var buttonBackward = jQuery('.player-button-backward');
    var buttonForward = jQuery('.player-button-forward');
    var buttonSpeed = jQuery('.player-button-speed');
    var buttonClose = jQuery('.player-button-close');
    var timeCurrent = jQuery('.player-time-current');
    var timeDuration = jQuery('.player-time-duration');

    jQuery('.site').on('click', '.js-play', function () {
        var clicked = jQuery(this);
        var url = clicked.attr('data-url');
        var id = clicked.attr('data-id');

        if (jQuery('.player-external').length) {
            body.addClass('player-opened');
        }

        if (id !== playerMedia.attr('data-id')) {
            // Change audio player url
            playerAudio.attr('src', url);

            // Change player thumbnail and call lazySizes
            playerThumbnail.attr(
                'data-srcset',
                clicked.closest('.post-image').attr('data-srcset')
            );
            lazySizes.loader.unveil(playerThumbnail[0]);

            // Change player title
            playerTitle.text(
                clicked.closest('.post').find('.post-title-link').text()
            );

            // Change player meta
            playerMeta.html(clicked.closest('.post').find('.post-meta').html());

            // Make previous episode button pause
            jQuery('.post-' + playerMedia.attr('data-id'))
                .find('.icon')
                .removeClass('icon-pause');

            // Change player media id attribute
            playerMedia.attr('data-id', id);
            buttonPlay.attr('data-id', id);

            // Select current episode button
            buttonEpisode = jQuery('[data-id="' + id + '"]').find('.icon-play');
        }

        if (playerAudio[0].paused) {
            var playPromise = playerAudio[0].play();
            if (playPromise !== undefined) {
                playPromise
                    .then(function () {
                        // Make clicked button pause
                        clicked.find('.icon').addClass('icon-pause');
                        // Make playing episode button pause
                        if (buttonEpisode) {
                            buttonEpisode.addClass('icon-pause');
                        }
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            }
        } else {
            playerAudio[0].pause();
            // Make clicked button play
            clicked.find('.icon').removeClass('icon-pause');
            // Make paused episode button play
            if (buttonEpisode) {
                buttonEpisode.removeClass('icon-pause');
            }
        }
    });

    playerAudio.on('loadedmetadata', function () {
        timeDuration.text(
            new Date(playerAudio[0].duration * 1000).toISOString().substr(11, 8)
        );
        playerAudio[0].addEventListener('timeupdate', function (e) {
            timeCurrent.text(
                new Date(e.target.currentTime * 1000)
                    .toISOString()
                    .substr(11, 8)
            );
            playerProgress.css(
                'width',
                (e.target.currentTime / playerAudio[0].duration) * 100 + '%'
            );
        });
    });

    buttonBackward.on('click', function () {
        playerAudio[0].currentTime = playerAudio[0].currentTime - 10;
    });

    buttonForward.on('click', function () {
        playerAudio[0].currentTime = playerAudio[0].currentTime + 30;
    });

    buttonSpeed.on('click', function () {
        if (playerSpeed < 2) {
            playerSpeed += 0.5;
        } else {
            playerSpeed = 1;
        }

        playerAudio[0].playbackRate = playerSpeed;
        buttonSpeed.text(playerSpeed + 'x');
    });
}

function pagination() {
    'use strict';
    var wrapper = $('.post-feed');

    if (body.hasClass('paged-next')) {
        wrapper.infiniteScroll({
            append: '.post',
            button: '.infinite-scroll-button',
            debug: false,
            hideNav: '.pagination',
            path: '.pagination .older-posts',
            scrollThreshold: false,
            status: '.infinite-scroll-status',
        });
    }
}

function popup() {
    'use strict';
    jQuery('.js-popup').on('click', function () {
        jQuery(this).parent().toggleClass('popup-opened');
    });
}

function subscribe() {
    'use strict';
    var subscribeButton = jQuery('.header-button-subscribe');
    var currentText = subscribeButton.text();
    var closeIcon = '<i class="icon icon-window-close"></i>';

    subscribeButton.on('click', function () {
        if (subscribeButton.parent().hasClass('popup-opened')) {
            subscribeButton.html(closeIcon);
        } else {
            subscribeButton.html(currentText);
        }
    });
}

/*
 * ----------------------------------------------------------------------------
 * "THE BEER-WARE LICENSE" (Revision 42):
 * Tuxes3 wrote this file. As long as you retain this notice you
 * can do whatever you want with this stuff. If we meet some day, and you think
 * this stuff is worth it, you can buy me a beer in return Tuxes3
 * ----------------------------------------------------------------------------
 */
(function($)
{
	var settings;
    $.fn.mTagCloud = function(options)
    {

    	//
    	// DEFAULT SETTINGS
    	//
    	settings = $.extend({
    		multiplier		: 1
    	}, options);
    	main(this);

    }

    function main(element)
    {
    	// adding style attr
    	element.addClass("m-tag-cloud");
    	addListElementFontSize(element);
    }

    /**
     * calculates the font size on each li element
     * according to their data-weight attribut
     */
    function addListElementFontSize(element)
    {
    	var hDataWeight = -9007199254740992;
    	var lDataWeight = 9007199254740992;
    	$.each(element.find("span"), function(){
    		cDataWeight = getDataWeight(this);
    		if (cDataWeight == undefined)
    		{
    			logWarning("No \"data-weight\" attribut defined on <span> element");
    		}
    		else
    		{
    			hDataWeight = cDataWeight > hDataWeight ? cDataWeight : hDataWeight;
    			lDataWeight = cDataWeight < lDataWeight ? cDataWeight : lDataWeight;
    		}
    	});
    	$.each(element.find("span"), function(){
    		var dataWeight = getDataWeight(this);
    		var percent = Math.abs((dataWeight - lDataWeight)/(lDataWeight - hDataWeight));
    		$(this).css('font-size', (1 + (percent * settings['multiplier'])) + "em").css('margin-top', (Math.floor(Math.random() * 20 - 10))+"px");
        if (percent >= .75) {
          $(this).children().first().css('color','#7D514B');
        }
    	});

    }

    function getDataWeight(element)
    {
    	return parseInt($(element).attr("data-weight"));
    }

    function logWarning(message)
    {
    	console.log("[WARNING] " + Date.now() + " : " + message);
    }

}(jQuery));

$(document).ready(function(){
  $(".tag-container").mTagCloud({
    multiplier: 3
  });
});
$(document).scroll(function() {
  var y = $(this).scrollTop();
  var z = $('#home').height();

  if ($(body).hasClass('home-template')){
    if (y > 600) {
      $('#player').fadeIn();
    } else {
      $('#player').fadeOut();
    }

    if  (y > z){
      $('.site-header').addClass("sticky-top");
    } else {
      $('.site-header').removeClass("sticky-top");
    }
  }
});
